import {createAction, props} from "@ngrx/store";
import {DocumentObject} from "../../models";

export const downloadDocument = createAction(
  '[Document] Download Document',
  props<{ id: string, fileName: string }>()
)

export const downloadDocumentSuccess = createAction(
  '[Document] Download Document Success',
  props<{ document: DocumentObject }>()
)

export const downloadDocumentError = createAction(
  '[Document] Download Document Error',
)
